<xi-calendar
  [data]="displayValueSignal()?.fixedRange"
  [checkedListId]="displayValueSignal()?.relativeRange"
  [mode]="calendarMode"
  [popoutView]="true"
  [localization]="{ firstInputPlaceholder: '- ' + placeholder(), secondInputPlaceholder: ' ' }"
  (onValueChange)="onFilterValueSet($event)"
  (onToggle)="calendarMode = $event.detail.mode"
></xi-calendar>
